import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

// Admin Components
import AdminLogin from './components/admin/AdminLogin';
import Dashboard from './components/admin/Dashboard';
import ProductManagement from './components/admin/ProductManagement';
import FridgeManagement from './components/admin/FridgeManagement';
import AssignProducts from './components/admin/AssignProducts';
import StockMonitoring from './components/admin/StockMonitoring';
import SalesReport from './components/admin/SalesReport';
import RefillSchedule from './components/admin/RefillSchedule';

// Customer Components
import Home from './components/customer/Home';
import Products from './components/customer/Products';
import Cart from './components/customer/Cart';
import Checkout from './components/customer/Checkout';
import OrderConfirmation from './components/customer/OrderConfirmation';

// QR Fridge Components
import QRScanner from './components/qr-customer/QRScanner';
import FridgeProducts from './components/qr-customer/FridgeProducts';
import FridgeCheckout from './components/qr-customer/FridgeCheckout';
import PaymentSuccess from './components/qr-customer/PaymentSuccess';

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <Toaster position="top-right" />
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/products" element={<ProductManagement />} />
            <Route path="/admin/fridges" element={<FridgeManagement />} />
            <Route path="/admin/assign-products" element={<AssignProducts />} />
            <Route path="/admin/stock" element={<StockMonitoring />} />
            <Route path="/admin/sales" element={<SalesReport />} />
            <Route path="/admin/refill" element={<RefillSchedule />} />
            
            {/* Customer Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-confirmation/:orderNumber" element={<OrderConfirmation />} />
            
            {/* QR Fridge Routes */}
            <Route path="/scan" element={<QRScanner />} />
            <Route path="/fridge/:fridgeId" element={<FridgeProducts />} />
            <Route path="/fridge-checkout" element={<FridgeCheckout />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;